import React from "react";

import emptyBag from "../assets/emptybag.png";

const EmptyCart = ({ showCart, setShowCart }) => {
  return (
    <div className="flex flex-col items-center h-full justify-center gap-7 ">
      <img
        src={emptyBag}
        alt="empty-cart"
        className="h-auto w-40 lg:-36 sm:w-[28] object-fill transition-all ease-in-out duration-300 hover:scale-110"
      />
      <button
        onClick={() => setShowCart(!showCart)}
        className="button-theme bg-gradient-to-b from-amber-500 to bg-orange-500 shadow-lg shadow-orange-500 text-slate-100 text-center font-normal capitalize hover:bg-slate-300 transition-all duration-300 ease-in-out "
      >
        back to store
      </button>
    </div>
  );
};

export default EmptyCart;
